import { render, staticRenderFns } from "./BandejaArrastre.vue?vue&type=template&id=9459855e"
import script from "./BandejaArrastre.vue?vue&type=script&lang=js"
export * from "./BandejaArrastre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports